import { Backdrop, CircularProgress } from '@mui/material'
import theme from 'theme'

export const LoadingBackdrop = ({
  open,
  spinnerColor = theme.palette.primary.dark,
  backgroundOpacity = 0.25,
}) => {
  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: (theme) =>
          Math.max.apply(Math, Object.values(theme.zIndex)) + 1,
        color: spinnerColor,
        backgroundColor: `rgba(0,0,0,${backgroundOpacity})`,
      }}
    >
      <CircularProgress color="inherit" size={'4em'} />
    </Backdrop>
  )
}
